import React, { useState } from 'react';
import { cn, getImageUrl } from '../lib/utils';

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
}

export function LazyImage({ src, alt, className, wrapperClassName, ...props }: LazyImageProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={cn("relative overflow-hidden bg-zinc-100 dark:bg-zinc-800/50", wrapperClassName)}>
      {/* Background placeholder / shimmer effect */}
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-200 via-zinc-100 to-zinc-200 dark:from-zinc-800 dark:via-zinc-700 dark:to-zinc-800 bg-[length:200%_100%] animate-pulse" style={{ animationDuration: '1.5s' }} />
      )}
      
      {hasError ? (
        <img
          src="https://images.unsplash.com/photo-1585829365295-ab7cd400c167?q=80&w=800&auto=format&fit=crop"
          alt="Fallback"
          className={cn("w-full h-full object-cover opacity-80", className)}
        />
      ) : (
        <img
          loading="lazy"
          decoding="async"
          src={getImageUrl(src)}
          alt={alt}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          className={cn(
            "transition-all duration-700 ease-out", 
            isLoaded ? "opacity-100 scale-100 blur-0" : "opacity-0 scale-105 blur-sm",
            className
          )}
          referrerPolicy="no-referrer"
          {...props}
        />
      )}
    </div>
  );
}
